import { i as l } from "../../util-b2b0dc25.js";
const c = l(), p = /([\:\-\_]+(.))/g, v = /^moz([A-Z])/, a = c ? 0 : Number(document.documentMode), w = function(t) {
  return (t || "").replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, "");
}, e = function(t) {
  return t.replace(p, function(n, r, i, o) {
    return o ? i.toUpperCase() : i;
  }).replace(v, "Moz$1");
}, h = function() {
  return !c && document.addEventListener ? function(t, n, r) {
    t && n && r && t.addEventListener(n, r, !1);
  } : function(t, n, r) {
    t && n && r && t.attachEvent("on" + n, r);
  };
}(), g = function() {
  return !c && document.removeEventListener ? function(t, n, r) {
    t && n && t.removeEventListener(n, r, !1);
  } : function(t, n, r) {
    t && n && t.detachEvent("on" + n, r);
  };
}(), S = function(t, n, r) {
  var i = function() {
    r && r.apply(this, arguments), g(t, n, i);
  };
  h(t, n, i);
};
function d(t, n) {
  if (!t || !n)
    return !1;
  if (n.indexOf(" ") !== -1)
    throw new Error("className should not contain space.");
  return t.classList ? t.classList.contains(n) : (" " + t.className + " ").indexOf(" " + n + " ") > -1;
}
function F(t, n) {
  if (t) {
    for (var r = t.className, i = (n || "").split(" "), o = 0, u = i.length; o < u; o++) {
      var s = i[o];
      s && (t.classList ? t.classList.add(s) : d(t, s) || (r += " " + s));
    }
    t.classList || t.setAttribute("class", r);
  }
}
function b(t, n) {
  if (!(!t || !n)) {
    for (var r = n.split(" "), i = " " + t.className + " ", o = 0, u = r.length; o < u; o++) {
      var s = r[o];
      s && (t.classList ? t.classList.remove(s) : d(t, s) && (i = i.replace(" " + s + " ", " ")));
    }
    t.classList || t.setAttribute("class", w(i));
  }
}
const f = a < 9 ? function(t, n) {
  if (!c) {
    if (!t || !n)
      return null;
    n = e(n), n === "float" && (n = "styleFloat");
    try {
      switch (n) {
        case "opacity":
          try {
            return t.filters.item("alpha").opacity / 100;
          } catch (r) {
            return 1;
          }
        default:
          return t.style[n] || t.currentStyle ? t.currentStyle[n] : null;
      }
    } catch (r) {
      return t.style[n];
    }
  }
} : function(t, n) {
  var i;
  if (!c) {
    if (!t || !n)
      return null;
    n = e(n), n === "float" && (n = "cssFloat");
    try {
      var r = (i = document.defaultView) == null ? void 0 : i.getComputedStyle(t, "");
      return t.style[n] || r ? r[n] : null;
    } catch (o) {
      return t.style[n];
    }
  }
};
function E(t, n, r) {
  if (!(!t || !n))
    if (typeof n == "object")
      for (var i in n)
        n.hasOwnProperty(i) && E(t, i, n[i]);
    else
      n = e(n), n === "opacity" && a < 9 ? t.style.filter = isNaN(r) ? "" : "alpha(opacity=" + r * 100 + ")" : t.style[n] = r;
}
const C = (t, n) => c ? void 0 : (n != null ? n ? f(t, "overflow-y") : f(t, "overflow-x") : f(t, "overflow")).match(/(scroll|auto|overlay)/), R = (t, n) => {
  if (c)
    return;
  let r = t;
  for (; r; ) {
    if ([window, document, document.documentElement].includes(r))
      return window;
    if (C(r, n))
      return r;
    r = r.parentNode;
  }
  return r;
}, A = (t, n) => {
  if (c || !t || !n)
    return !1;
  const r = t.getBoundingClientRect();
  let i;
  return [window, document, document.documentElement, null, void 0].includes(
    n
  ) ? i = {
    top: 0,
    right: window.innerWidth,
    bottom: window.innerHeight,
    left: 0
  } : i = n.getBoundingClientRect(), r.top < i.bottom && r.bottom > i.top && r.right > i.left && r.left < i.right;
};
export {
  F as addClass,
  R as getScrollContainer,
  f as getStyle,
  d as hasClass,
  A as isInContainer,
  C as isScroll,
  g as off,
  h as on,
  S as once,
  b as removeClass,
  E as setStyle
};
